import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../../context/FirebaseConfig';
import { EVENT_LOGS_COLLECTION_PATH } from '../../shared_components/utils/FirebaseUtils';
import { buildEventLog } from './buildEventLog';

/**
 * Transport for user activity events: writes one `event_logs` document.
 *
 * `event_logs` is the only destination — metrics are read from our own dashboard, so there is no
 * Firebase Analytics leg to keep in step.
 *
 * Logging must never affect the action it describes, so the write is fire and forget: it is not
 * awaited and every failure is caught and warned about. Firestore runs with offline persistence on
 * these devices, so a write started while the tablet is offline is queued locally and flushed on
 * reconnect — which also means a rejected write only reports itself once connectivity returns.
 */

/**
 * Log one user action.
 *
 * @param {Object} params
 * @param {string} params.eventName - Name from `EVENT_NAMES`; an unregistered name is dropped.
 * @param {Object} [params.eventParams] - Event params; snake_case keys, no PII.
 * @param {Object} [params.session] - Session identity, injected by the logger, not the caller.
 * @returns {void}
 */
export function writeEventLog({ eventName, eventParams, session } = {}) {
  const eventLog = buildEventLog({ eventName, eventParams, session });

  if (!eventLog) {
    console.warn('Event not logged, name is not registered in EVENT_NAMES:', eventName);
    return;
  }

  addDoc(collection(firestore, EVENT_LOGS_COLLECTION_PATH), { ...eventLog, timestamp: serverTimestamp() }).catch(
    (error) => console.warn('Event log write failed', error),
  );
}
